import { logEvent } from 'firebase/analytics';
import { analytics } from './firebase';

export const EVENTS = {
  USER_SIGNED_UP: 'user_signed_up',
  USER_LOGGED_IN: 'user_logged_in',
  TRAINING_SESSION_STARTED: 'training_session_started',
  DRILL_SELECTED: 'drill_selected',
  DRILL_TIMER_STARTED: 'drill_timer_started',
  DRILL_TIMER_PAUSED: 'drill_timer_paused',
  DRILL_COMPLETED: 'drill_completed',
  DRILL_EDITED: 'drill_edited',
  DRILL_DELETED: 'drill_deleted',
  TRAINING_SESSION_COMPLETED: 'training_session_completed',
  TRAINING_SESSION_EDITED: 'training_session_edited',
  STREAK_INCREMENTED: 'streak_incremented',
  STREAK_MILESTONE: 'streak_milestone',
  DAILY_GOAL_REACHED: 'daily_goal_reached',
  HOME_VIEWED: 'home_viewed',
  PROGRESS_VIEWED: 'progress_viewed',
  SETTINGS_VIEWED: 'settings_viewed',
  SETTINGS_UPDATED: 'settings_updated',
  BELT_CHANGED: 'belt_changed',
  NOTIFICATION_PERMISSION_GRANTED: 'notification_permission_granted',
  NOTIFICATION_CLICKED: 'notification_clicked',
  RECOMMENDATION_DISMISSED: 'recommendation_dismissed',
  ERROR_OCCURRED: 'error_occurred',
  CUSTOM_LIST_CREATED: 'custom_list_created',
  CUSTOM_LIST_EDITED: 'custom_list_edited',
  CUSTOM_LIST_STARTED_DROPDOWN: 'custom_list_started_dropdown',
  CUSTOM_LIST_STARTED_SAVE: 'custom_list_started_save'
};

export const trackEvent = (eventName, params = {}) => {
  console.log('Analytics event:', eventName, params);
  logEvent(analytics, eventName, {
    ...params,
    timestamp: new Date().toISOString()
  });
};